import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { CountryItem, Country } from '../models';

export class CountryApi extends ApiModule {
  protected endpoint = '/country';

  public async pageCountrys(params: any) {
    return this.api.post<PaginatedResponseData<CountryItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadCountryDetails(id: number) {
    return this.api.get<Country>(`${this.endpoint}?id=${id}`);
  }

  public saveCountry(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteCountry(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
